// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__11jJo","label":"Section_label__2kDW1","contentWrap":"Section_contentWrap__2AucC","footer":"Section_footer__2ybo9","footerInner":"Section_footerInner__Uth-I"};